<template>
	<div>
        <div class="margin-top-20">
            <!-- BOL -->
            <section class="margin-bottom-10" v-if="transType == 1">
                <vFormItem class="margin-bottom-10" label="BOL(PDF,JPG,PNG)"></vFormItem>
                <div class="margin-bottom-10">
                    <span v-for="(item,index) in dataList.filter( item => item.attachType == 'BOL')" :key="index" class="margin-right-10" style="background:#f0f2f5; padding: 0 8px; border-radius: 4px;font-weight: 400">
                        <Tooltip placement="top">
                            <div slot="content">
                                {{item.filename}}
                            </div>
                            <a @click="downloadFile(item)">
                                {{item.filename.length > 20 ? item.filename.slice(0,20).concat('...') : item.filename || "-"}}
                            </a>
                        </Tooltip>
                        <b class="margin-left-10" @click="removeItems(item)" style="cursor:pointer;">×</b>
                    </span>
                </div>
                <vButton @click=" showAttach = true; fileType = 'BOL'">
                    <Icon type="ios-cloud-upload" size="16" style="color: black; margin-right: 5px"></Icon>
                    <span>Upload Files</span>
                </vButton>
            </section>
            <!-- ItemLabel -->
            <section class="margin-bottom-10" v-if="valueAddedService && valueAddedService.indexOf(1) > -1">
                <vFormItem class="margin-bottom-10" label="ItemLabel(PDF,JPG,PNG)" required prop="ItemLabel"></vFormItem>
                <div class="margin-bottom-10">
                    <span v-for="(item,index) in dataList.filter( item => item.attachType == 'ItemLabel')" :key="index" class="margin-right-10" style="background:#f0f2f5; padding: 0 8px; border-radius: 4px;font-weight: 400">
                        <Tooltip placement="top">
                            <div slot="content">
                                {{item.filename}}
                            </div>
                            <a @click="downloadFile(item)">
                                {{item.filename.length > 20 ? item.filename.slice(0,20).concat('...') : item.filename || "-"}}
                            </a>
                        </Tooltip>
                        <b class="margin-left-10" @click="removeItems(item)" style="cursor:pointer;">×</b>
                    </span>
                </div>
                <vButton @click=" showAttach = true; fileType = 'ItemLabel'">
                    <Icon type="ios-cloud-upload" size="16" style="color: black; margin-right: 5px"></Icon>
                    <span>Upload Files</span>
                </vButton>
            </section>
            <!-- PalletLabel -->
            <section class="margin-bottom-10" v-if="valueAddedService && valueAddedService.indexOf(3) > -1">
                <vFormItem class="margin-bottom-10" label="PalletLabel(PDF,JPG,PNG)" ></vFormItem>
                <div class="margin-bottom-10">
                    <span v-for="(item,index) in dataList.filter( item => item.attachType == 'PalletLabel')" :key="index" class="margin-right-10" style="background:#f0f2f5; padding: 0 8px; border-radius: 4px;font-weight: 400">
                        <Tooltip placement="top">
                            <div slot="content">
                                {{item.filename}}
                            </div>
                            <a @click="downloadFile(item)">
                                {{item.filename.length > 20 ? item.filename.slice(0,20).concat('...') : item.filename || "-"}}
                            </a>
                        </Tooltip>
                        <b class="margin-left-10" @click="removeItems(item)" style="cursor:pointer;">×</b>
                    </span>
                </div>
                <vButton @click=" showAttach = true; fileType = 'PalletLabel'">
                    <Icon type="ios-cloud-upload" size="16" style="color: black; margin-right: 5px"></Icon>
                    <span>Upload Files</span>
                </vButton>
            </section>
            <!-- CartonLabel -->
            <section class="margin-bottom-10" v-if="valueAddedService && valueAddedService.indexOf(2) > -1">
                <vFormItem class="margin-bottom-10" label="CartonLabel(PDF,JPG,PNG)" required prop="CartonLabel"></vFormItem>
                <div class="margin-bottom-10">
                    <span v-for="(item,index) in dataList.filter( item => item.attachType == 'CartonLabel')" :key="index" class="margin-right-10" style="background:#f0f2f5; padding: 0 8px; border-radius: 4px;font-weight: 400">
                        <Tooltip placement="top">
                            <div slot="content">
                                {{item.filename}}
                            </div>
                            <a @click="downloadFile(item)">
                                {{item.filename.length > 20 ? item.filename.slice(0,20).concat('...') : item.filename || "-"}}
                            </a>
                        </Tooltip>
                        <b class="margin-left-10" @click="removeItems(item)" style="cursor:pointer;">×</b>
                    </span>
                </div>
                <vButton @click=" showAttach = true; fileType = 'CartonLabel'">
                    <Icon type="ios-cloud-upload" size="16" style="color: black; margin-right: 5px"></Icon>
                    <span>Upload Files</span>
                </vButton>
            </section>
            <!-- Shippinglabel -->
            <section class="margin-bottom-10" v-if="transType == 2">
                <vFormItem class="margin-bottom-10" label="Shippinglabel(PDF,JPG,PNG)" :required="transportationType == 4 ? true : false" prop="Shippinglabel"></vFormItem>
                <div class="margin-bottom-10">
                    <span v-for="(item,index) in dataList.filter( item => item.attachType == 'Shippinglabel')" :key="index" class="margin-right-10" style="background:#f0f2f5; padding: 0 8px; border-radius: 4px;font-weight: 400">
                        <Tooltip placement="top">
                            <div slot="content">
                                {{item.filename}}
                            </div>
                            <a @click="downloadFile(item)">
                                {{item.filename.length > 20 ? item.filename.slice(0,20).concat('...') : item.filename || "-"}}
                            </a>
                        </Tooltip>
                        <b class="margin-left-10" @click="removeItems(item)" style="cursor:pointer;">×</b>
                    </span>
                </div>
                <vButton @click=" showAttach = true; fileType = 'Shippinglabel'">
                    <Icon type="ios-cloud-upload" size="16" style="color: black; margin-right: 5px"></Icon>
                    <span>Upload Files</span>
                </vButton>
            </section>
            <!-- Other -->
            <section class="margin-bottom-10">
                <vFormItem class="margin-bottom-10" label="Other" ></vFormItem>
                <div class="margin-bottom-10">
                    <span v-for="(item,index) in dataList.filter( item => item.attachType == 'Other')" :key="index" class="margin-right-10" style="background:#f0f2f5; padding: 0 8px; border-radius: 4px;font-weight: 400">
                        <Tooltip placement="top">
                            <div slot="content">
                                {{item.filename}}
                            </div>
                            <a @click="downloadFile(item)">
                                {{item.filename.length > 20 ? item.filename.slice(0,20).concat('...') : item.filename || "-"}}
                            </a>
                        </Tooltip>
                        <b class="margin-left-10" @click="removeItems(item)" style="cursor:pointer;">×</b>
                    </span>
                </div>
                <vButton @click="showAttach=true;fileType='Other'" >
                    <Icon type="ios-cloud-upload" size="16" style="color: black; margin-top: 3px; margin-right: 5px"></Icon>
                    <span>Upload Files</span>
                </vButton>
            </section>
        </div>
		<vModal v-model="showAttach" :title="$t('global.common.import',{defaultValue:'导入数据'})" :showFooter="false">
            <div v-if="fileType === 'BOL'">
                <vCol span="12">
                    <vFormItem label-width="auto" :label="$t('fbb.truck.company', { defaultValue: '卡车公司' })" class="margin-right-10" >
                        <vInput :placeholder="$t('fbb.truck.companyname', { defaultValue: '卡车公司名称' })" :value="truckOrgName" @on-blur="getTruckName"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem label-width="auto" :label="$t('fbb.transfer.deliverydate', { defaultValue: '提货日期' })" class="margin-right-10">
                        <vDatepicker v-model="deliveryTime" format="yyyy-mm-dd" :confirm="false" :placeholder="$t('fbb.transfer.boldeliverydate', { defaultValue: 'BOL提货日期' })"></vDatepicker>
                    </vFormItem>
                </vCol>
            </div>
			<!-- <compUpload v-bind="getFileProps" @on-close="showAttach=false" @on-success="handleAttach" /> -->
			<compMutiUpload v-bind="getFileProps" @on-cancel="close" @on-success="handleAttach" />
		</vModal>
        <compModal v-model="modalProps.show" v-bind="modalProps" @on-close="closemodalprops" @on-confirm="modalProps.show=false">
			<component v-if="modalProps.component" :is="modalProps.component" v-bind="modalProps.props" @on-close="closemodalprops" v-on="modalProps.on"/>
		</compModal>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</div>
</template>

<script>
import { HttpUploadAttach, HttpDelAttach } from '@/service/allotment';

export default {
	props: ['data', 'status','activeid',  'querytype', 'isLabel', 'transType', 'transportationType', 'isManage', 'goodsMessage'],
	components: {
		compUpload: () => import("@components/templates/upload"),
        compMutiUpload: () => import("@components/templates/mutiUpload"),
	},
	data() {
		return {
			type: this.querytype || this.$route.params.type,
			id: this.$route.query.id || "",
			showAttach: false,
            isManageBill: this.isManage ? 0 : 1 ,
			fileType: 'Other',
            truckOrgName: '',
            deliveryTime: '',
            valueAddedService: [],
            attachMeta:{},
			attachMetas:[],
			loading: false,
			dataList: this.data || [],
            modalProps: {
				show: false,
				formdata: null,
			},
		}
	},
	created() {
		if(this.activeid){
			this.id = this.activeid
		}
	},
	watch: {
		data(val) {
			this.dataList = val || [];
		},
        isLabel(val) {
            this.valueAddedService = val
        },
        goodsMessage(val){
            this.truckOrgName = val.truckOrgName || '';
            this.deliveryTime = val.deliveryTime || '';
        },
	},
	computed: {
        getFileProps() {
			return {
                action: process.env.VUE_APP_APIURL_FBB + "/api/v2/TransferOutboundPlan/uploadAttach",
				name: "multipartFile",
				data: {
                    attachType: this.fileType,
					isManageBill: this.isManageBill,
					transferOutboundPlanId: this.id,
                    truckCompany: this.truckOrgName,
                    pickupTime: this.deliveryTime
				},
                multiple: true,
                formatter: (res) => {
                    this.$Message.success({
                        content: res.message,
                        duration: 30,
                        closable: true,
                    });
                    this.handleAttach(res.data)
                    return res.data;
                },
                beforeUpload:(file)=>{
                    if(file.length === 0){
                        return false
                    } else if(this.fileType === 'BOL' && file.length > 0){
                        if(!this.truckOrgName || !this.deliveryTime){
                            this.$Message.error({
                                content: this.$t('fbb.transfer.uploadbolcheck', { defaultValue: '上传BOL类型文件请填写卡车公司和提货日期！' }),
                                duration: 30,
                                closable: true,
                            });
                            return false
                        }
                    }
                    return true
                },
				accept: this.fileType === 'Other' ? '' : 'image/*,application/pdf'
			}
		},
	},
	methods: {
        getTruckName(val){
            this.truckOrgName = val
        },
        close(){
            this.showAttach = false;
        },
        closemodalprops(){
            this.modalProps = {};
            this.$emit('on-openCloseable');
        },
        async handleAttach(res) {
			this.dataList.push(res.orderAttaches[0]);
            this.update();
			this.close();
		},
        downloadFile(item){
            this.handleWebfs(item.fileurl, {}, 'download')
        },
		async removeItems(obj) {
            this.modalProps = {
				show: true,
				title: this.$t('fbb.transfer.deleteattach', { defaultValue: '删除附件' }),
				alert: "error",
                desc: this.$t('fbb.markchange.deletemark', { defaultValue: '附件删除不可恢复，是否确认？' }),
				showDesc: true,
				params: { transferOutboundPlanId: this.id, isManageBill: this.type == 'add' ? null: this.isManageBill, attachmentIds: obj.id },
				ajaxRequest: HttpDelAttach,
                callback:(res)=>{
                    this.$Message.success({
                        content: res.message,
                        duration: 30,
                        closable: true,
                    });
                    const index = this.dataList.findIndex( item=> item.id === obj.id);
                    this.dataList.splice(index,1)
                    this.update();
                }
			};
		},
        update(){
            if(this.fileType === 'BOL'){
                this.dataList.truckOrgName = this.truckOrgName;
                this.dataList.deliveryTime = this.deliveryTime;
            }
            this.$emit('on-update', this.dataList)
        }
	}
}
</script>
